<template>
  <section>
    <div class="content-devx padding-half">
      <div class="vademecum-product-warning">
        <slot>
          default warning text
        </slot>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: "ProductWarning",
  components: {},
  computed: {},
  methods: {},
};
</script>

<style>
.vademecum-product-warning {
  color: #0071BD;
  font-weight: bold;
}
</style>
